import React from "react";
import { toSortableMillis } from "../utils/firestoreDates";

export function quotationActorLabel(quote = {}, members = [], editor = false) {
  const uid = editor ? quote.lastEditedBy || quote.updatedBy : quote.createdByUid || quote.createdBy;
  const snapshot = editor ? quote.lastEditedByName : quote.createdByName || quote.createdByDisplayName;
  const member = uid && members.find(item => item.uid === uid || item.id === uid);
  return snapshot || member?.name || member?.displayName || (uid
    ? "Recorded user (name unavailable)" : editor ? "Not recorded" : "Creator unknown (legacy quotation)");
}

export default function QuotationAttribution({ quote, members = [], compact = false }) {
  if (!quote) return null;
  const date = value => {
    const millis = toSortableMillis(value);
    return millis > 0 ? new Date(millis).toLocaleString("en-IN") : "Not recorded";
  };
  return <div style={{ fontSize: 12, lineHeight: 1.6, marginTop: 6 }}>
    <div>Created by: {quotationActorLabel(quote, members)}</div>
    {!compact ? <>
      <div>Created on: {date(quote.createdAt)}</div>
      <div>Last edited by: {quotationActorLabel(quote, members, true)}</div>
      <div>Last edited: {date(quote.lastEditedAt || quote.updatedAt)}</div>
    </> : null}
  </div>;
}
